<script setup lang="ts">
import { searchTextChanged } from "@/analytics/events/search";
import { trackEvent } from "@/analytics/track";
import BaseInput from "@/components/ui/BaseInput/BaseInput.vue";
import { useNativeEvents } from "@/composables/useNativeEvents";
import { eventTarget } from "@/utils/dom/dom";

const model = defineModel<string>({ required: true });
const emit = defineEmits<{ toggle: [] }>();

// the three funcs bellow are only used for analytics
const onInput = () => {
  trackEvent(searchTextChanged());
};

const { addEventListener, removeEventListeners } = useNativeEvents();
const handleInputFocus = (event: FocusEvent) => {
  addEventListener(eventTarget(event), "input", onInput, { once: true });
};
</script>

<template>
  <BaseInput
    v-model="model"
    v-autofocus
    control-type="text"
    class="search-bar allow-shortcuts"
    maxlength="100"
    :placeholder="$t('action.searchPlaceholder')"
    @focus="handleInputFocus"
    @blur="removeEventListeners"
    @keydown.esc="emit('toggle')"
  />
</template>

<style lang="scss">
.search-bar {
  min-width: 297px;
}
</style>
